import DashboardLayout from "./layouts/dashboard";
import UserPage from "./pages/Admin/UserPage";
// KEPT: Admin login functionality - admin login still required
import LoginPage from "./pages/Admin/LoginPage";
import SubScriptionManagementPage from "./pages/Admin/SubScriptionManagementPage";
import CutomersPaymentsPage from "./pages/Admin/CutomersPaymentsPage";
import CMSPage from "./pages/Admin/CMSPage";
import ProfilePage from "./pages/Admin/ProfilePage";
import ChangePasswordPage from "./pages/Admin/ChangePasswordPage";
import FormManagementPage from "./pages/Admin/FormManagementPage";
import EditCMSPage from "./pages/Admin/EditCMSPage";
import AddEditFormManagementPage from "./pages/Admin/AddEditFormManagementPage";
import AddEditMGAUserPage from "./pages/Admin/AddEditMGAUserPage";
import EditSubScriptionManagementPage from "./pages/Admin/EditSubScriptionManagementPage";
import UserLicenseKeyPage from "./pages/Admin/UserLicenseKeyPage";
import { useRoutes } from "react-router-dom";
import PDFSectionFormManagment from "./pages/Admin/PDFSectionFormManagment";
import NotFoundPageForAdmin from "./pages/Admin/NotFoundPage";
import CarrierManagementPage from "./pages/Admin/CarrierManagementPage";
import PolicyManagementPage from "./pages/Admin/PolicyManagementPage";
import AddEditCarrierForm from "./pages/Admin/AddEditCarrierForm";
import AddEditPolicyForm from "./pages/Admin/AddEditPolicyForm";
import { paths } from "./utils/constants";
import MgaPage from "./pages/Admin/MgaPage";
import AddEditMgaPage from "./pages/Admin/AddEditMgaPage";
import AccessLogsPage from "./pages/Admin/AccessLogsPage";
import AdaRequestsPage from "./pages/Admin/AdaRequestsPage";
import VideoManagementPage from "./pages/Admin/VideoManagementPage";
import AddEditVideoPage from "./pages/Admin/AddEditVideoPage";

export default function Router() {
  const routes = useRoutes([
    // KEPT: Admin login page - admin login still required
    {
      path: paths.adminRoutes.ADMIN,
      element: <LoginPage />,
    },
    {
      path: paths.adminRoutes.DASHBOARD,
      element: <DashboardLayout />,
      children: [
        { path: `user`, element: <UserPage /> },
        {
          path: "user/addEditUser",
          element: <AddEditMGAUserPage />,
        },
        { path: `mga`, element: <MgaPage /> },
        {
          path: "mga/addEditMGA",
          element: <AddEditMgaPage />,
        },
        {
          path: `subscription`,
          element: <SubScriptionManagementPage />,
        },
        {
          path: "subscription/editSubscription",
          element: <EditSubScriptionManagementPage />,
        },
        { path: `cutomerPayments`, element: <CutomersPaymentsPage /> },
        { path: "formManagement", element: <FormManagementPage /> },
        {
          path: "formManagement/editForm",
          element: <AddEditFormManagementPage />,
        },
        {
          path: "formManagement/editForm/PDFSectionFormManagment",
          element: <PDFSectionFormManagment />,
        },
        {
          path: "carriers",
          element: <CarrierManagementPage />,
        },
        {
          path: "carriers/addEditCarrier",
          element: <AddEditCarrierForm />,
        },
        {
          path: "policies",
          element: <PolicyManagementPage />,
        },
        {
          path: "policies/addEditPolicy",
          element: <AddEditPolicyForm />,
        },
        { path: "userLicenseKeys", element: <UserLicenseKeyPage /> },
        { path: `cmsPage`, element: <CMSPage /> },
        {
          path: "cmsPage/editCMSPage",
          element: <EditCMSPage />,
        },
        {
          path: `profilePage`,
          element: <ProfilePage />,
        },
        {
          path: `changePassword`,
          element: <ChangePasswordPage />,
        },
        {
          path: `accessLogs`,
          element: <AccessLogsPage />,
        },
        {
          path: `adaRequests`,
          element: <AdaRequestsPage />,
        },
        {
          path: `videos`,
          element: <VideoManagementPage />,
        },
        {
          path: "videos/uploadVideo",
          element: <AddEditVideoPage />,
        },
        {
          path: "videos/editVideo",
          element: <AddEditVideoPage />,
        },
        {
          path: paths.adminRoutes.DASHBOARD,
          element: <NotFoundPageForAdmin />,
        },
        {
          path: "*",
          element: <NotFoundPageForAdmin />,
        },
      ],
    },
    // KEPT: Default admin login redirect - admin login still required
    {
      path: "*",
      element: <LoginPage />,
    },
  ]);
  return routes;
}
